import baseAPI from '@/http'

const router = 'api/projeto/grupoSolucao'

export const groupSolutionAPI = {
  create: (groupSolution) => baseAPI.post(router, groupSolution),
  update: (project) => baseAPI.put(router, project),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  listNotInCity: (id) => baseAPI.get(`${router}/list-not-in-municipio/${id}`)
}
